import React from 'react'
import PensilSvg from 'images/modules/Shared/i-pencil.svg?raw'

export { default as PensilUrl } from 'images/modules/Shared/i-pencil.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: PensilSvg}} />
)
